export const getters = {
  getBalanceUnilevel: state => state.balanceUnilevel,
  getBalanceToken: state => state.balanceToken,
  getBalanceInvestment: state => state.balanceInvestment
};

export default {};
